import { Base64 } from 'js-base64';
import { setRAGNodeFormData } from 'js/actions/rag';
import getAiKeysFromType from 'js/components/pipelines/cards/hooks/getAiKeysFromType';
import useReusableTransforms from 'js/components/pipelines/cards/hooks/useReusableTransforms';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export default function useAiContainerData(data, type) {
  const dispatch = useAppDispatch();
  const settedContainerProps = useRef(false);
  const { code_container_id: linkedContainerId, flow_node_id: flowNodeId } = data;
  const { reusableTransforms, transforms } = useReusableTransforms(type);
  const { typeFieldKey, codeFieldKey, typePropFieldKey, promptVar } = getAiKeysFromType(type);
  const formData = useSelector((state: any) => state.rag.nodeFormData[flowNodeId]);
  const codeContainerId = formData?.codeContainerId || -1;
  const linkedCodeContainer = transforms[linkedContainerId];
  const createdCodeContainer = transforms[codeContainerId];

  const initialFormData = {
    [typeFieldKey]: linkedCodeContainer?.reusable ? String(linkedContainerId) : 'custom',
    [codeFieldKey]:
      linkedCodeContainer &&
      !linkedCodeContainer.reusable &&
      linkedCodeContainer.code_encoding === 'base64'
        ? Base64.decode(linkedCodeContainer.code)
        : `${promptVar} = "Prompt goes here"`,
  };

  useEffect(() => {
    if (!formData) {
      dispatch(setRAGNodeFormData(flowNodeId, initialFormData));
    }
  }, []);

  const setFormData = (newFormData: any) => {
    dispatch(setRAGNodeFormData(flowNodeId, newFormData));
  };

  const setCreatedCodeContainer = (codeContainerId: number) => {
    setFormData({
      ...formData,
      codeContainerId,
    });
  };

  useEffect(() => {
    if (linkedCodeContainer && !settedContainerProps.current) {
      const defaultRewriter = reusableTransforms.find((t) =>
        t.custom_config?.props?.find?.((prop) => prop[typePropFieldKey] === 'default'),
      );
      settedContainerProps.current = true;
      const dataProps = data?.custom_config?.props || {};
      const codeProps = linkedCodeContainer?.custom_config?.props || [];
      const props = codeProps.reduce((map, prop) => {
        map[prop.name] = dataProps[prop.name] || prop.default;
        return map;
      }, {});
      if (codeProps.length) {
        setFormData({
          [typeFieldKey]: linkedCodeContainer?.reusable
            ? String(linkedContainerId)
            : defaultRewriter.id,
          [codeFieldKey]:
            linkedCodeContainer &&
            !linkedCodeContainer.reusable &&
            linkedCodeContainer.code_encoding === 'base64'
              ? Base64.decode(linkedCodeContainer.code)
              : `${promptVar} = "Prompt goes here"`,
          ...(formData || {}),
          ...props,
        });
      }
    }
  }, [linkedCodeContainer]);

  return {
    setCreatedCodeContainer,
    linkedCodeContainer,
    createdCodeContainer,
    formData: formData || initialFormData,
    setFormData,
  };
}
